import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServiceSection from "@/components/ServiceSection";
import InstagramBanner from "@/components/InstagramBanner";
import Footer from "@/components/Footer";
import ReviewsSection from "@/components/ReviewsSection";
import PartnersSection from "@/components/PartnersSection";
import StatsSection from "@/components/StatsSection";
import PortfolioPreview from "@/components/PortfolioPreview";
import TestimonialsSection from "@/components/TestimonialsSection";
import TrustedBySection from "@/components/TrustedBySection";
import SponsorsSection from "@/components/SponsorsSection";
import SEO from "@/components/SEO";
const Index = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen flex flex-col">
      <SEO
        title="Prebitit - Digital Solutions Expertly Crafted"
        description="Istanbul-based studio building custom websites, mobile apps, AI tools, camera systems and high-performance PCs. Bring your digital vision to life."
        path="/"
      />
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        <TrustedBySection />
        <PartnersSection />
        <ServiceSection />
        <StatsSection />
        <TestimonialsSection />
        
        <PortfolioPreview />
        <SponsorsSection />
        <InstagramBanner />
      </main>
      <Footer />
    </div>;
};
export default Index;